<template>
  <div id="promotions-list">
    <SidebarLayout2
      :breadcrumb="breadcrumb"
      pageTitle="Agrupador de promoções da rede "
    >
      <!-- BARRA LATERAL -->
      <template #sidebar>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <Heading>
            Ações da página
          </Heading>

          <PmwButton
            :hasIcon="true"
            :link="'/promocoes/novo'"
            variation="pmw-primary"
            element="router-link"
            class="page-actions--button"
          >
            Criar agrupador
          </PmwButton>

          <PmwButton
            :disabled="disableEditPmwButton"
            variation="pmw-primary"
            class="page-actions--button"
            tooltipText="Selecione um agrupador na tabela para editar."
            @click.stop.prevent="
              $router.push({
                path: `/promocoes/editar/${selectedRows[0].codigo}`
              })
            "
          >
            Editar
          </PmwButton>

          <PmwButton
            v-show="showInactivateButton"
            :disabled="disabledDeletePmwButton"
            tooltipText="Selecione um agrupador na tabela para desativar."
            variation="red-100"
            class="page-actions--button"
            @click.stop.prevent="deleteModal(selectedRows.codigo)"
          >
            Desativar
          </PmwButton>

          <PmwButton
            v-show="showReactivateButton"
            variation="pmw-primary"
            class="page-actions--button"
            @click.stop.prevent="reactivatePromotion(selectedRows[0].codigo)"
          >
            Reativar
          </PmwButton>
        </SidebarBlock>

        <!-- DICAS -->
        <SidebarBlock>
          <Heading>
            Dica
          </Heading>
          <Paragraph class="page-actions--tip-text">
            Agrupe tarifas promocionais, com a mesma temática comercial de
            diferentes hotéis da rede, para divulgação na home do seu Site
            Letsbook.
          </Paragraph>
        </SidebarBlock>
      </template>
      <!-- CONTEÚDO -->
      <template #content>
        <div class="filters">
          <!-- BUSCA -->
          <SearchInput
            v-model="filterByName"
            placeholder="Buscar por agrupador"
            class="filters--search-input"
          />
        </div>
        <span class="extra-filters">
          <!-- FILTRO STATUS -->
          <FilterDropdown
            v-model="statusFilter"
            :options="statusFilterOptions"
            class="extra-filters--status"
          />

          <!-- FILTRO HOTEL -->
          <FilterDropdown
            v-model="hotelFilter"
            :options="hotelsOptions"
            :radioOptions="false"
            :hasSearch="true"
            :fieldsToSearch="['label']"
            toggleAllLabel="Todos"
            searchFieldPlaceholder="Selecionar agrupador"
            label="Hotel"
            class="extra-filters--status"
          />

          <!-- FILTRO TARIFA -->
          <FilterDropdown
            v-model="rateFilter"
            :options="rateFilterOptions"
            :radioOptions="false"
            :hasSearch="true"
            :fieldsToSearch="['label']"
            checkboxNoSelectionLabel="Todas"
            searchFieldPlaceholder="Selecionar tarifa"
            label="Tarifas"
            class="extra-filters--status"
          />
        </span>

        <!-- TABELA -->
        <DataTable
          :cols="cols"
          :colsMinWidths="colsMinWidths"
          :sortable="true"
          :isLoading="loading"
          :rows="rows"
          :selectableRow="true"
          ref="dataTable"
          maxHeight="1080"
          class="datatable"
          @getSelectedRows="selectedRows = $event"
        >
          <template v-slot:ativo="data">
            {{ data.rowDataObj.ativo ? 'Ativo' : 'Inativo' }}
          </template>
          <template v-slot:status="data">
            <div v-if="data.rowDataObj.ativo == true" class="datatable--text">
              Ativo
            </div>
            <div v-else>
              Inativo
            </div>
          </template>

          <template v-slot:editar="data">
            <button
              class="links--edit"
              @click.stop.prevent="
                $router.push({
                  path: `promocoes/editar/${data.rowDataObj.codigo}`
                })
              "
            >
              Editar
            </button>
          </template>

          <template v-slot:excluir="slotProps">
            <button
              v-if="slotProps.rowDataObj.ativo === true"
              class="links--delete"
              @click.stop.prevent="deleteModal(slotProps.rowDataObj.codigo)"
            >
              Desativar
            </button>
            <button
              v-else
              class="links--reactivate"
              @click.stop.prevent="
                reactivatePromotion(slotProps.rowDataObj.codigo)
              "
            >
              Reativar
            </button>
          </template>
        </DataTable>
        <!-- PAGINAÇÃO -->
        <PmwPagination
          :items="filterPromotions"
          :itemsPerPage="pagination.itemsPerPage"
          :currentPage="pagination.currentPage"
          :totalItems="filterPromotions.length"
          :itemsPerPageOptions="pagination.itemsPerPageOptions"
          class="pagination"
          @changePagination="changePagination"
        />
        <!-- MODAL DELEÇÃO -->
        <AlertModal
          v-model="showDeleteModal"
          :buttonClose="true"
          title="Desativar agrupador de promoção"
          @alert-modal-cancel="cancelDisable()"
          @alert-modal-confirm="disablePromotion()"
        >
          <template #text>
            Ao desativar, a promoção da rede gerada a partir deste agrupador não
            estará mais diponível no seu Site Letsbook. <br />
            Tem certeza que quer fazer isso?
          </template>
        </AlertModal>
      </template>
    </SidebarLayout2>
  </div>
</template>

<script>
import { removeStringAccents } from '@/helpers/string.js'
import debounce from 'lodash.debounce'

import AlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import DataTable from '@solucoes/components-lib-tmp/src/components/patterns/DataTable'
import FilterDropdown from '@solucoes/components-lib-tmp/src/components/patterns/FilterDropdown'

import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import PmwPagination from '@solucoes/components-lib-tmp/src/components/patterns/PmwPagination'
import SearchInput from '@solucoes/components-lib-tmp/src/components/elements/SearchInput'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import Paragraph from '@solucoes/components-lib-tmp/src/components/elements/Paragraph'
import SidebarLayout2 from '@/layouts/SidebarLayout2'

export default {
  name: 'PromotionsList',
  components: {
    AlertModal,
    PmwButton,
    DataTable,
    FilterDropdown,
    Heading,
    PmwPagination,
    SearchInput,
    SidebarLayout2,
    SidebarBlock,
    Paragraph
  },
  data() {
    return {
      breadcrumb: [
        {
          label: 'Site Letsbook'
        },
        {
          label: 'Agrupador de promoções da rede'
        }
      ],
      /** Colunas da tabela */
      cols: [
        {
          alias: 'Nome',
          name: 'promocao'
        },
        {
          name: 'ativo',
          alias: 'Status'
        },
        {
          alias: 'Ações',
          name: 'editar'
        },
        {
          name: 'excluir'
        }
      ],
      /** Tamanho mínimo das colunas */
      colsMinWidths: {
        promocao: '500px',
        status: '100px',
        editar: '80px',
        excluir: '80px'
      },
      /** V-model da busca */
      filterByName: '',
      /** Dados da paginação */
      pagination: {
        totalItems: 0,
        currentPage: 1,
        itemsPerPage: 25,
        startItemIndex: 1,
        lastItemIndex: 25,
        itemsPerPageOptions: [
          {
            text: '25',
            value: 25
          },
          {
            text: '50',
            value: 50
          },
          {
            text: '75',
            value: 75
          },
          {
            text: '100',
            value: 100
          }
        ]
      },
      /** Linhas da tabela (dados) */
      rows: [],
      /** Armazena dados de retorno */
      allPromotions: [],
      /** Loading da tabela */
      loading: false,
      /** Array das linhas selecionadas */
      selectedRows: [],
      /** Usuário a ser deletado */
      promotionDelete: null,
      /** Exibição da modal de deleção */
      showDeleteModal: false,
      /** Opções do filtro de status */
      statusFilterOptions: [
        {
          label: 'Todos',
          value: -1,
          checked: false
        },
        {
          label: 'Ativo',
          value: 1,
          checked: true
        },
        {
          label: 'Inativo',
          value: 0,
          checked: false
        }
      ],
      /** Opções do filtro de hotel */
      hotelsOptions: [],
      /** Input de pesquisa de hoteis */
      searchHotel: '',
      hotelFilterOptions: [],
      /** Opções do filtro de hotel */
      rateFilterOptions: [],
      /** V-model do filtro de status */
      statusFilter: {
        label: 'Ativo',
        value: -1,
        checked: true
      },
      /** V-model do filtro de hotel */
      hotelFilter: [],
      /** V-model do filtro de tarifa */
      rateFilter: [],
      totalHotelsLenght: null
    }
  },
  computed: {
    showInactivateButton() {
      /** Exibição do botão de inativar */
      const isActive = this.selectedRows.some((item) => {
        return !item.ativo
      })
      if (!isActive) {
        return true
      }
      return false
    },
    showReactivateButton() {
      /** Exibição do botão de reativar amenidade */
      if (this.selectedRows.length === 1 && !this.selectedRows[0].ativo) {
        return true
      }
      return false
    },
    disabledDeletePmwButton() {
      if (this.selectedRows.length >= 1) {
        return false
      }
      return true
    },
    disableEditPmwButton() {
      if (this.selectedRows.length === 1) {
        return false
      }
      return true
    },

    /** Filtro da tela de expirado e nome */
    filterPromotions() {
      /** Carrega a tabela de acordo com os valores dos filtros (nome e status) */
      return this.allPromotions.reduce((acc, curr) => {
        let match = true

        /** Filtra por status */
        match =
          +curr.data.ativo === +this.statusFilter.value ||
          +this.statusFilter.value === -1

        if (match) {
          acc.push(curr)
        }

        /** Filtra por nome */
        const results = acc.filter(
          (data) =>
            removeStringAccents(data.data.promocao)
              .toLowerCase()
              .indexOf(removeStringAccents(this.filterByName).toLowerCase()) >
            -1
        )

        return results
      }, [])
    },
    filterValues() {
      return {
        codigoTarifa: this.rateFilter.map((rate) => rate.value).join(','),
        codigoHotel: this.hotelFilter.map((hotel) => hotel.value).join(',')
      }
    }
  },
  /** Usado para fazer a requisição de filtro */
  watch: {
    filterValues: {
      handler: debounce(function(newVal, oldVal) {
        if (
          newVal &&
          (newVal.codigoTarifa !== oldVal.codigoTarifa ||
            newVal.codigoHotel !== oldVal.codigoHotel)
        ) {
          this.filterPromotion()
          this.paginationCurrentPage = 1
        }
      }, 100)
    }
  },
  async created() {
    /** Faz a chamada da api */
    await this.getAllPromotions()
    await this.getHotels()
    await this.getRates()
  },
  methods: {
    /** Resquisição de filtro */
    filterPromotion() {
      this.loading = true

      const filters = {}

      if (this.statusFilter.value !== -1) {
        filters.ativo = this.statusFilter.value > 0
      }

      /** Se selecionar todas as tarifas, envia um array vazio para não derrubar o server */
      if (this.rateFilter.length > 0) {
        filters.tarifas =
          this.rateFilter.length ===
          this.rateFilterOptions.flatMap((item) => item.subfields).length
            ? []
            : this.rateFilter.map((item) => item.value)
      }

      if (this.hotelFilter.length > 0) {
        filters.hoteis =
          this.hotelFilter.length === this.hotelsOptions.length
            ? []
            : this.hotelFilter.map((item) => item.value)
      }

      this.$promotionsBundler.filterPromotions(filters).then((response) => {
        this.allPromotions = this.standarizeRowsData(response.data)
        this.loading = false
      })
    },

    /** Retorna tarifas para filtro  */
    getRates() {
      /** Filtro de tarifas */
      this.$rate
        .getFluctuationRates({
          tamanhoPagina: +this.totalHotelsLenght,
          apenasFlutuacoesAtivas: true,
          apenasTarifasPromocionais: true
        })
        .then((response) => {
          for (let i = 0, len = response.data.itens.length; i < len; i++) {
            const item = response.data.itens[i]
            const obj = {}

            obj.fieldset = item.nome
            obj.subfields = []

            for (let j = 0, lenj = item.tarifas.length; j < lenj; j++) {
              const rate = item.tarifas[j]
              const subRate = {}

              subRate.label = rate.descricao
              subRate.value = rate.codigo

              obj.subfields.push(subRate)
            }

            this.rateFilterOptions.push(obj)
          }
        })
    },

    /** Busca todos as promoções  */
    getAllPromotions() {
      this.loading = true
      this.$promotionsBundler.get().then((response) => {
        this.allPromotions = this.standarizeRowsData(response.data)
      })
      this.loading = false
      this.selectedRows = []
    },

    /** Busca os hoteis para o filtro  */
    async getHotels() {
      await this.$hotel.getShortenedHotelsList().then((response) => {
        this.totalHotelsLenght = response.data.length
        response.data.forEach((item) => {
          const obj = {}

          obj.label = item.nome
          obj.value = item.codigo

          this.hotelsOptions.push(obj)
        })
      })
    },

    standarizeRowsData(data) {
      /** Padroniza os dados para popular a tabela */
      const array = []
      let nome = ''

      data.forEach((item) => {
        /** Encontra o nome da promocao em português */
        const index = item.idiomas?.findIndex((langItem) => {
          return langItem.idioma === 'pt-BR'
        })

        nome =
          index !== -1 && item.idiomas[index] ? item.idiomas[index].nome : ''

        array.push({
          data: {
            promocao: nome,
            codigo: item.codigo,
            ativo: item.ativo,
            idiomas: item.idiomas,
            tarifas: item.flutuacoesTarifarias
          }
        })
      })

      /** Retorna o array com os dados em ordem alfabética */
      return array.sort((a, b) => {
        const firstItem = removeStringAccents(a.data.promocao).toLowerCase()
        const nextItem = removeStringAccents(b.data.promocao).toLowerCase()
        if (firstItem > nextItem) {
          return 1
        } else if (firstItem < nextItem) {
          return -1
        } else {
          return 0
        }
      })
    },

    /** Desabilitar usuário */
    disablePromotion() {
      const DeletePromotion = this.ifExists(
        this.selectedRows.length > 0
          ? this.selectedRows.map((item) => {
              return parseInt(item.codigo)
            })
          : [this.promotionDelete]
      )
      this.$promotionsBundler
        .disablePromotion({ promocoes: DeletePromotion })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Agrupador de promoções desativado com sucesso'
          })
          this.getAllPromotions()
          this.resetPagination()
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao desativar agrupador de promoções'
          })
        })
    },

    /** Reativar usuário */
    reactivatePromotion(id) {
      this.$promotionsBundler
        .reactivatePromotion(id)
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Agrupador de promoção reativado com sucesso'
          })
          this.getAllPromotions()
          this.resetPagination()
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.messages[0]
          })
        })
    },

    /** Controle de deleção */
    deleteModal(userId) {
      this.showDeleteModal = true
      this.promotionDelete = userId
    },

    /** Cancela deleção */
    cancelDisable() {
      this.showDeleteModal = false
      this.promotionDelete = null
    },

    /** Verificar se dado existe */
    ifExists(element) {
      /** se for array */
      let result = null
      if (element && typeof element.value !== 'undefined') {
        result = element.value
        /** se for string */
      } else if (element !== '') {
        result = element
      }
      return result === true ? 1 : result
    },

    /** Usado para controle da paginação */
    changePagination(childData) {
      this.pagination.currentPage = childData.currentPage
      this.rows = childData.items
    },

    /** Reseta dados da paginação */
    resetPagination() {
      this.pagination.currentPage = 1
      this.pagination.startItemIndex = 1
      this.pagination.itemsPerPage = 25
      this.pagination.lastItemIndex = this.pagination.itemsPerPage
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
}

.pagination {
  ::v-deep {
    p {
      margin: 0;
    }
    .select--button {
      font-weight: 500;
    }
  }
}
::v-deep .content {
  /** Padding abaixo do título da página */
  .page-heading {
    padding-bottom: 24px;
  }
}
::v-deep .datable-grid-wrapper {
  .col {
    padding-left: 14px;
  }
}
.sidebar {
  &-title {
    line-height: 21px;
    color: $gray-darkest;
    text-align: left;
    margin-top: 35px;
    margin-bottom: 15px;
    margin-left: 15px;
  }
  &-buttons {
    display: flex;
    flex-direction: column;
    width: 215px;
    gap: 10px;
    margin: auto;
  }
}
.filters {
  display: flex;
  gap: 20px;

  &--search-input {
    width: 215px;
  }

  &--more {
    width: 225px;
  }
}
.extra-filters {
  display: flex;
  margin-top: 15px;
  margin-bottom: 30px;

  &--status {
    width: 160px;
  }
}
.links {
  &--edit {
    color: #466af0;
    font-weight: 500;
    border: none;
    padding-left: 10px;
    background-color: inherit;
  }
  &--reactivate {
    color: #466af0;
    font-weight: 500;
    border: none;
    background-color: inherit;
  }
  &--delete {
    color: #e0414b;
    font-weight: 500;
    border: none;
    background-color: inherit;
  }
}

::v-deep .pmw-datatable-wrapper__overflow {
  max-height: none;

  .pmw-col.pmw-th:nth-child(4) {
    max-width: 70px;
  }
  .pmw-col.pmw-th:nth-child(4) {
    border-right: none;
  }
  .pmw-col.pmw-th:nth-child(5) {
    max-width: 70px;
  }
  .pmw-col.pmw-th:nth-child(4),
  .pmw-col.pmw-th:nth-child(5) {
    pointer-events: none;
    .pmw-sort-icons {
      display: none;
    }
  }
  .pmw-col.pmw-th:nth-child(3),
  .pmw-col.pmw-td:nth-child(3) {
    max-width: 77px;
  }

  .pmw-col.pmw-td:nth-child(5),
  .pmw-col.pmw-td:nth-child(4) {
    justify-content: center;
    max-width: 70px;
  }
}

.datatable {
  .action {
    &--item {
      font-size: font-size('size-small');
    }
  }
  &--text {
    text-align: center;
  }
}
.filters-select {
  display: flex;
  width: 100%;
  position: relative;
  height: 40px;
  border: none;
  border-bottom: 1px solid $gray-darkest;

  & ::v-deep .pmw-dropdown--trigger-button {
    /** Remove o espaço antes do texto do dropdown de mais filtros */
    padding: 0;
  }
}
.page-actions {
  padding-top: 50px;
  &--button {
    width: 100%;
    cursor: pointer;

    & + .page-actions--button {
      margin-top: 10px;
    }
  }
  &--tip-text {
    color: $gray-darkest;
    font-size: 14px;
    line-height: 21px;
    max-width: 215px;
  }
}
</style>
